<template>
    <div class="sub-group-select">
        <b-dropdown
            class="apprentice-custom-select child-group-select"
            id="dropdown-left"
            :text="title"
            variant="primary"
            menu-class="sub-group-select-menu"
            :right="true">
            <b-dropdown-text tag="div">
                <design-2021-apprentice-tree-view-component
                    :data="treeIn"
                    children="all_children"
                    :indent="15"
                    :selected="selected">
                </design-2021-apprentice-tree-view-component>
            </b-dropdown-text>
        </b-dropdown>
    </div>
</template>

<script>
import { CommonBus } from '../../../app';

function findProject(id, groups) {
    for (const group of groups) {
        if (group.id === id) {
            return group;
        }
        const result = findProject(id, group.all_children);
        if (result) {
            return result;
        }
    }
    return null;
}

export default {
    name: 'design-2021-group-show-child-select-component',
    props: ['treeIn', 'groupId'],
    data() {
        return {
            selected: this.groupId,
            title: this.$t('group.select_class'),
        };
    },
    methods: {
        url(id) {
            return this.routes.groupShow(id);
        },
    },
    mounted() {
        const item = findProject(this.groupId, this.treeIn);

        if (item && item.parent_id) {
            this.title = item.name;
        }

        CommonBus.$emit('tree-view-selected-item', item);

        CommonBus.$on('tree-view-selected-item', (item) => {
            if (item.id === this.groupId) {
                return;
            }

            window.location.href = this.url(item.id);
        });
    },
};
</script>

<style scoped lang="scss">
.child-group-select ::v-deep {
    .sub-group-select-menu {
        overflow-y: auto;
        max-height: calc(100vh - 275px);
    }

    .dropdown-menu {
        padding: map-get($grid-gutter-spacing, 'fifteen');
        width: calc(100vw - 30px);
        left: -5px !important;

        .b-dropdown-text {
            padding-left: 0;
            padding-right: 0;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .child-group-select ::v-deep {
        .dropdown-menu {
            width: max-content;
            max-width: 300px;
            min-width: 250px;
            left: 0 !important;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .child-group-select ::v-deep {
        .sub-group-select-menu {
            overflow-y: auto;
            max-height: calc(100vh - 261px);
        }
    }
}
</style>
